<template>
    <template v-if="visible">
        <template v-for="(banner, index) in banners" :key="index">
            <Banner :testId="banner.testId" :content="banner.content" :ctaLabel="banner.ctaLabel" :ctaLink="banner.ctaLink" :collapsed="banner.collapsed" />
        </template>
    </template>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useBannerStore } from "@/store/banner/banner.state";
import Banner from "./Banner.vue";
import { IContentBanner } from "@/interfaces/self-service/content-banner.js";

export interface BannerListProps {
    banners?: IContentBanner[];
}
const {
    banners
} = defineProps<BannerListProps>();

const state = useBannerStore();

const visible = computed(() => state.showSelfServicePolicyBanners);

</script>